import { type StateCreator } from 'zustand';

import { type AnnotationType } from '@air/api/types';
import { teal } from '@air/colors';

export type AnnotationTool = 'point' | 'box' | 'pencil';

export type AnnotationSessionSlice = {
  annotationColor: string;
  annotationSize: number;
  annotationType: AnnotationType;
  isAnnotationsEnabled: boolean;
  isDrawing: boolean;
  selectedTool: AnnotationTool;
  shouldEnableCommentTimestamps: boolean;
  resetAnnotationSession: () => void;
  setAnnotationColor: (color: string) => void;
  setAnnotationSize: (size: number) => void;
  setAnnotationType: (type: AnnotationType) => void;
  setAnnotationsEnabled: (enabled: boolean) => void;
  setIsDrawing: (isDrawing: boolean) => void;
  setSelectedTool: (tool: AnnotationTool) => void;
  setShouldEnableCommentTimestamps: (enabled: boolean) => void;
};

export type AnnotationSessionSliceInitialState = Pick<
  AnnotationSessionSlice,
  | 'annotationColor'
  | 'annotationSize'
  | 'annotationType'
  | 'isAnnotationsEnabled'
  | 'isDrawing'
  | 'selectedTool'
  | 'shouldEnableCommentTimestamps'
>;

export const INITIAL_ANNOTATION_SESSION_STATE: AnnotationSessionSliceInitialState = {
  annotationColor: teal.teal7.hex,
  annotationSize: 3,
  annotationType: 'box',
  isAnnotationsEnabled: false,
  isDrawing: false,
  selectedTool: 'point',
  shouldEnableCommentTimestamps: true,
};

export type CreateAnnotationSessionSlice = (
  initialState?: Partial<AnnotationSessionSliceInitialState>,
) => StateCreator<AnnotationSessionSlice, [], [], AnnotationSessionSlice>;

export const createAnnotationSessionSlice: CreateAnnotationSessionSlice = (initialState) => (set) => {
  const mergedInitialState: AnnotationSessionSliceInitialState = {
    ...INITIAL_ANNOTATION_SESSION_STATE,
    ...initialState,
  };

  return {
    ...mergedInitialState,
    resetAnnotationSession: () => set({ ...mergedInitialState }),
    setAnnotationColor: (annotationColor) => set({ annotationColor }),
    setAnnotationSize: (annotationSize) => set({ annotationSize }),
    setAnnotationType: (annotationType) => set({ annotationType }),
    setAnnotationsEnabled: (isAnnotationsEnabled) => set({ isAnnotationsEnabled }),
    setIsDrawing: (isDrawing) => set({ isDrawing }),
    setSelectedTool: (selectedTool) => set({ selectedTool }),
    setShouldEnableCommentTimestamps: (shouldEnableCommentTimestamps) => set({ shouldEnableCommentTimestamps }),
  };
};
